/**
 * The placeholders this automation's template may use (D10).
 *
 * THE SERVER'S CATALOGUE, AS SENT. One entry per placeholder the template
 * endpoint returned for this automation, in its order, with its example value
 * — nothing added, nothing hidden, no free-form `{{ … }}` field. A key without
 * a German word here is shown as the key.
 *
 * INSERTING NEEDS A PLACE. A placeholder goes where the caret was last, in the
 * subject or a paragraph; until a field has had the caret, the buttons are
 * disabled and say so instead of inserting somewhere surprising. Read-only
 * (a template that cannot be authored) shows the same list without buttons.
 */
import React from "react";
import { Plus } from "lucide-react";

import { placeholderLabel } from "./automationTemplateLabels";

export default function AutomationTemplatePlaceholders({
  placeholders,
  readOnly = false,
  canInsert = false,
  onInsert,
}) {
  const items = Array.isArray(placeholders) ? placeholders : [];
  if (!items.length) {
    return (
      <p className="m-0 text-[12px] text-muted-foreground">
        Für diese Vorlage gibt es keine Platzhalter.
      </p>
    );
  }
  return (
    <div className="flex flex-col gap-2">
      <ul aria-label="Platzhalter" className="m-0 flex list-none flex-wrap gap-1.5 p-0">
        {items.map((placeholder) => {
          const label = placeholderLabel(placeholder.key);
          const hint = placeholder.nullable
            ? `Beispiel: ${placeholder.example_value} · kann leer sein`
            : `Beispiel: ${placeholder.example_value}`;
          return (
            <li key={placeholder.key} className="max-w-full">
              {readOnly ? (
                <span
                  title={hint}
                  className="inline-flex max-w-full items-center rounded-full border border-border bg-muted/40 px-2.5 py-1 text-[12px] text-foreground"
                >
                  <span className="break-all">{label}</span>
                </span>
              ) : (
                <button
                  type="button"
                  disabled={!canInsert}
                  title={hint}
                  aria-label={`Platzhalter ${label} einfügen`}
                  onMouseDown={(event) => event.preventDefault()}
                  onClick={() => onInsert(placeholder.key)}
                  className="inline-flex max-w-full items-center gap-1 rounded-full border border-primary/30 bg-primary/10 px-2.5 py-1 text-[12px] font-medium text-primary hover:bg-primary/15 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50 max-md:min-h-9"
                >
                  <Plus className="h-3 w-3 shrink-0" aria-hidden="true" />
                  <span className="break-all">{label}</span>
                </button>
              )}
            </li>
          );
        })}
      </ul>
      {readOnly ? null : (
        <p className="m-0 text-[11.5px] text-muted-foreground">
          {canInsert
            ? "Ein Platzhalter wird dort eingefügt, wo der Cursor zuletzt stand."
            : "Zuerst in den Betreff oder einen Absatz klicken, dann einen Platzhalter wählen."}
        </p>
      )}
    </div>
  );
}
